import { render, staticRenderFns } from "./BoardAdd.vue?vue&type=template&id=d0cc0342&scoped=true"
import script from "./BoardAdd.vue?vue&type=script&lang=js"
export * from "./BoardAdd.vue?vue&type=script&lang=js"
import style0 from "./BoardAdd.vue?vue&type=style&index=0&id=d0cc0342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc0342",
  null
  
)

export default component.exports